/**
 * @type {number|null}
 */
var calibratedPxPerMM = null;

// Load calibration from localStorage if available
(function() {
  var stored = localStorage.getItem('calibratedPxPerMM');
  if (stored && !isNaN(Number(stored))) {
    calibratedPxPerMM = Number(stored);
  }
})();

function getPxPerMM() {
  if (calibratedPxPerMM) return calibratedPxPerMM;
  var stored = localStorage.getItem('calibratedPxPerMM');
  if (stored && !isNaN(Number(stored))) {
    calibratedPxPerMM = Number(stored);
    return calibratedPxPerMM;
  }
  // Fallback: use a reasonable default (e.g., 4 px/mm) and optionally show a warning
  // window.alert('Please calibrate using the ₹10 coin for accurate sizing.'); // Removed as per request
  return 4; // Default px per mm if not calibrated
}

function initCalibrationSection() {
  var slider = document.getElementById('calibration-slider');
  var value = document.getElementById('calibration-value');
  var circle = document.getElementById('calibration-circle');
  var doneBtn = document.getElementById('calibration-done');
  if (!slider || !value || !circle || !doneBtn) return;
  /** @type {HTMLInputElement} */
  var sliderInput = /** @type {HTMLInputElement} */(slider);
  /** @type {HTMLButtonElement} */
  var doneButton = /** @type {HTMLButtonElement} */(doneBtn);

  // Restore calibration state if available
  var storedPxPerMM = localStorage.getItem('calibratedPxPerMM');
  var storedCalibPx = localStorage.getItem('calibratedPx');
  if (storedPxPerMM && !isNaN(Number(storedPxPerMM)) && storedCalibPx && !isNaN(Number(storedCalibPx))) {
    sliderInput.value = storedCalibPx;
    value.textContent = storedCalibPx;
    circle.style.width = storedCalibPx + 'px';
    circle.style.height = storedCalibPx + 'px';
    doneButton.textContent = 'Calibrated!';
    doneButton.disabled = true;
    sliderInput.disabled = true;
  } else {
    function updateCalibrationCircle() {
      if (!sliderInput || !value || !circle) return;
      var px = Number(sliderInput.value);
      value.textContent = sliderInput.value;
      circle.style.width = px + 'px';
      circle.style.height = px + 'px';
    }
    sliderInput.addEventListener('input', updateCalibrationCircle);
    updateCalibrationCircle();
    doneButton.addEventListener('click', function() {
      if (!sliderInput || !circle || !doneButton) return;
      var px = Number(sliderInput.value);
      var pxPerMM = px / 27; // 27mm is the coin diameter
      calibratedPxPerMM = pxPerMM;
      localStorage.setItem('calibratedPxPerMM', String(calibratedPxPerMM));
      localStorage.setItem('calibratedPx', String(px));
      doneButton.textContent = 'Calibrated!';
      doneButton.disabled = true;
      sliderInput.disabled = true;
      window.location.reload();
    });
  }
}

/**
 * @param {HTMLElement} context
 */
function initRingSizeSection(context) {
  /** @type {HTMLInputElement|null} */
  var slider = context.querySelector('#ring-size-slider');
  /** @type {HTMLElement|null} */
  var value = context.querySelector('#ring-size-value');
  /** @type {HTMLElement|null} */
  var circle = context.querySelector('#ring-size-circle');
  var tableContainer = context.querySelector('.ring-size-table-container');
  var table = context.querySelector('.ring-size-table');
  var allRows = table ? table.querySelectorAll('tbody tr') : [];
  var storedRingSizeDiv = context.querySelector('#stored-ring-size');
  
  if (!slider || !value || !circle) return;
  
  function updateStoredRingSizeDisplay() {
    if (!storedRingSizeDiv) return;
    var ringSize = localStorage.getItem('ringSize');
    var ringSizeDiameter = localStorage.getItem('ringSizeDiameter');
    storedRingSizeDiv.textContent = (ringSize && ringSizeDiameter) ? 'Nearest Ring Size: Indian Size ' + ringSize + ' (' + ringSizeDiameter + ' mm)' : '';
  }
  
  function scrollToRingSize(diameter) {
    if (!tableContainer || !table || allRows.length === 0) return;
    var closest = null;
    var minDiff = Infinity;
    allRows.forEach(function(row) {
      var value = parseFloat(row.children[1].textContent);
      var diff = Math.abs(value - diameter);
      if (diff < minDiff) {
        minDiff = diff;
        closest = row;
      }
    });
    if (closest) {
      tableContainer.scrollTop = closest.offsetTop - (table.tHead ? table.tHead.offsetHeight : 0);
      allRows.forEach(function(row) { row.classList.remove('highlight-row'); });
      closest.classList.add('highlight-row');
      localStorage.setItem('ringSize', closest.children[0].textContent);
      localStorage.setItem('ringSizeDiameter', closest.children[1].textContent);
      updateStoredRingSizeDisplay();
    }
  }
  
  function updateCircle() {
    if (!slider || !value || !circle) return;
    var mm = Number(slider.value);
    value.textContent = slider.value;
    var px = mm * getPxPerMM();
    circle.style.width = px + 'px';
    circle.style.height = px + 'px';
    scrollToRingSize(mm);
  }
  
  slider.addEventListener('input', updateCircle);
  
  // Initialize with stored value or default
  var storedDiameter = localStorage.getItem('ringSizeDiameter');
  if (storedDiameter) {
    slider.value = storedDiameter;
    scrollToRingSize(parseFloat(storedDiameter));
  } else {
    scrollToRingSize(parseFloat(slider.value));
  }
  
  updateCircle();
  updateStoredRingSizeDisplay();
}

function initCalibrationReset() {
  var calibReset = document.getElementById('calibration-reset');
  var calibSlider = document.getElementById('calibration-slider');
  var calibValue = document.getElementById('calibration-value');
  var calibCircle = document.getElementById('calibration-circle');
  var calibDone = document.getElementById('calibration-done');
  
  if (calibReset && calibSlider && calibValue && calibCircle && calibDone) {
    calibReset.addEventListener('click', function() {
      localStorage.removeItem('calibratedPxPerMM');
      localStorage.removeItem('calibratedPx');
      calibSlider.disabled = false;
      calibDone.disabled = false;
      calibDone.textContent = 'Calibrate';
      calibSlider.value = 100;
      calibValue.textContent = '100';
      calibCircle.style.width = '100px';
      calibCircle.style.height = '100px';
      window.location.reload();
    });
  }
}

// For static and dynamically loaded sections
function setupRingSizeSections() {
  document.querySelectorAll('.ring-size-section').forEach(initRingSizeSection);
}

document.addEventListener('shopify:section:load', setupRingSizeSections);
document.addEventListener('DOMContentLoaded', function() {
  initCalibrationSection();
  initCalibrationReset();
  setupRingSizeSections();
}); 